import React, { Component, PropTypes } from 'react';
import { LineChart, Line } from 'recharts';

export default class ChartContainer extends Component {

  static propTypes = {
    data: PropTypes.array.isRequired,
    dataKey: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    customStyle: PropTypes.object
  };

  shouldComponentUpdate (nextProps, nextState) {
    let newData = nextProps.data;
    let { dataKey } = this.props;
    if (this.props.data === newData) {
      return false;
    }

    if (this.props.data.length !== newData.length) {
      return true;
    }

    return this.props.data.some((point, index) => {
      return (point[dataKey] !== newData[index][dataKey]);
    });
  }

  render () {
    const { width, height, customStyle } = this.props;
    return (
      <div>
        <LineChart width={width || 230} height={height || 40} data={this.props.data} style={customStyle}>
          <Line dataKey={this.props.dataKey} stroke='#5b8cec' strokeWidth={2} dot={false}/>
        </LineChart>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/ChartContainer.js
 **/